enum PixelTypeColor {
  RemoteControl = "137, 198, 255",

  CoverageLight = "206, 235, 211",
  Coverage = "188, 232, 200",
  CoverageDark = "150, 219, 169",
  CoverageVeryDark = "112, 206, 130",

  Forbidden = "0, 0, 0",
  SubZones = "200, 200, 200",
  PlannedPath = "194, 146, 128",
  Unknown = "242, 244, 247",
  Free = "255, 255, 255",
  ActiveRedZones = "211, 47 , 47",
  Robot = "14, 143, 243",
  RoomLimitZone = "0, 0, 0",
}

export default PixelTypeColor;

export const getColorFromPixelType = (coverage: PixelTypeColor, isCoverage: boolean) => {
  const colorArray = coverage
    .toString()
    .split(",")
    .map((value) => parseInt(value, 10));
  colorArray.push(isCoverage ? (coverage === PixelTypeColor.Free ? 0 : 1) : 1);
  return colorArray;
};

export const precomputedCoverageColorMap = new Array(256).fill([0, 0, 0, 255]);
precomputedCoverageColorMap[1] = getColorFromPixelType(PixelTypeColor.Coverage, true); // UNDOCK
precomputedCoverageColorMap[2] = getColorFromPixelType(PixelTypeColor.Coverage, true); // DOCK
precomputedCoverageColorMap[3] = getColorFromPixelType(PixelTypeColor.Coverage, true); // HOME
precomputedCoverageColorMap[4] = getColorFromPixelType(PixelTypeColor.CoverageVeryDark, true); // WALLFOLLOW
precomputedCoverageColorMap[5] = getColorFromPixelType(PixelTypeColor.CoverageLight, true); // RANDOM
precomputedCoverageColorMap[6] = getColorFromPixelType(PixelTypeColor.CoverageDark, true); // OPENSPACE
precomputedCoverageColorMap[7] = getColorFromPixelType(PixelTypeColor.Coverage, true); // REMAP
precomputedCoverageColorMap[8] = getColorFromPixelType(PixelTypeColor.RemoteControl, true); // RC
precomputedCoverageColorMap[9] = getColorFromPixelType(PixelTypeColor.Coverage, true); // UNKNOWN
precomputedCoverageColorMap[0] = getColorFromPixelType(PixelTypeColor.Free, true);
precomputedCoverageColorMap[254] = getColorFromPixelType(PixelTypeColor.Forbidden, true);
precomputedCoverageColorMap[255] = getColorFromPixelType(PixelTypeColor.Unknown, true);

export const precomputedObstacleColorMap = new Array(256).fill([0, 0, 0, 255]);
precomputedObstacleColorMap[0] = getColorFromPixelType(PixelTypeColor.Free, false);
precomputedObstacleColorMap[1] = getColorFromPixelType(PixelTypeColor.Coverage, false); // UNDOCK
precomputedObstacleColorMap[2] = getColorFromPixelType(PixelTypeColor.Coverage, false); // DOCK
precomputedObstacleColorMap[3] = getColorFromPixelType(PixelTypeColor.Coverage, false); // HOME
precomputedObstacleColorMap[4] = getColorFromPixelType(PixelTypeColor.CoverageVeryDark, false); // WALLFOLLOW
precomputedObstacleColorMap[5] = getColorFromPixelType(PixelTypeColor.CoverageLight, false); // RANDOM
precomputedObstacleColorMap[6] = getColorFromPixelType(PixelTypeColor.CoverageDark, false); // OPENSPACE
precomputedObstacleColorMap[7] = getColorFromPixelType(PixelTypeColor.Coverage, false); // REMAP
precomputedObstacleColorMap[8] = getColorFromPixelType(PixelTypeColor.RemoteControl, false); // RC
precomputedObstacleColorMap[9] = getColorFromPixelType(PixelTypeColor.Coverage, false); // UNKNOWN
precomputedObstacleColorMap[254] = getColorFromPixelType(PixelTypeColor.Forbidden, false);
precomputedObstacleColorMap[255] = getColorFromPixelType(PixelTypeColor.Unknown, false);

export const remapImagePixels = (imageData: ImageData, isCoverage: boolean) => {
  const data = imageData.data;
  for (let i = 0; i < data.length; i += 4) {
    const value = data[i];
    const color = isCoverage ? precomputedCoverageColorMap[value] : precomputedObstacleColorMap[value];
    // Apply the color to the pixel
    data[i] = color[0]; // Red
    data[i + 1] = color[1]; // Green
    data[i + 2] = color[2]; // Blue
    data[i + 3] = color[3] * 255; // Alpha
  }
  return imageData;
};
